<template>
  <a-modal
    :title="title"
    :visible="cropperVisible"
    @cancel="cancel"
    width="800px"
  >
    <div class="cropper-content">
      <!-- 剪裁框 -->
      <div class="cropper">
        <vue-cropper
          ref="cropper"
          :img="imgFile"
          :outputSize="option.size"
          :outputType="option.outputType"
          :info="true"
          :full="option.full"
          :canMove="option.canMove"
          :canMoveBox="option.canMoveBox"
          :original="option.original"
          :autoCrop="option.autoCrop"
          :autoCropWidth="option.autoCropWidth"
          :autoCropHeight="option.autoCropHeight"
          :fixedBox="option.fixedBox"
          @realTime="realTime"
          :fixed="option.fixed"
          :fixed-number="option.fixedNumber"
        ></vue-cropper>
      </div>
      <!-- 预览框 -->
      <div class="show-preview">
          <div :style="previews.div" class="preview">
              <img :src="previews.url" :style="previews.img">
          </div>
      </div>
    </div>
    <div slot="footer">
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" @click="uploadImg('base64')">确认裁剪</a-button>
    </div>
  </a-modal>
</template>

<script>
import { VueCropper } from 'vue-cropper'
import { mapState, mapMutations } from 'vuex';
export default {
  components: {VueCropper},
  data() {
    return {
      previews: {}, // 预览数据
      option: {
        img: '', // 裁剪图片的地址  (默认：空)
        size: 1, // 裁剪生成图片的质量  (默认:1)
        full: false, // 是否输出原图比例的截图 选true生成的图片会非常大  (默认:false)
        outputType: 'jpg', // 裁剪生成图片的格式  (默认:jpg)
        canMove: true, // 上传图片是否可以移动  (默认:true)
        original: false, // 上传图片按照原始比例渲染  (默认:false)
        canMoveBox: true, // 截图框能否拖动  (默认:true)
        autoCrop: true, // 是否默认生成截图框  (默认:false)
        autoCropWidth: 432, // * (256 / 320), // 默认生成截图框宽度  (默认:80%)
        autoCropHeight: 576, // * (256 / 320), // 默认生成截图框高度  (默认:80%)
        fixedBox: false, // 固定截图框大小 不允许改变  (默认:false)
        fixedNumber: [432,576], // 截图框比例  (默认:[1:1])
        fixed: true, // 是否开启截图框宽高固定比例  (默认:true)
        centerBox: true,
      },
      downImg: '#',
      titleArr: ['裁剪图片','裁剪图片']
    }
  },
  watch: {
    modelKey(val){
      this.getFixedNumber(val)
    },
  },
  computed: {
    ...mapState('news', ['cropperVisible','imgFile','titleKey','addKey','modelKey']),
    title(){
      return '裁剪图片'
    },
  },
  created() {},
  mounted() {
    this.getFixedNumber(this.modelKey)
  },
  methods: {
    ...mapMutations('news', ['setState']),
    getFixedNumber(val){
      if(val == 0){
        this.option.fixedNumber = [432,576]
        this.option.autoCropWidth = 432
        this.option.autoCropHeight = 576
      }else if(val == 1){
        this.option.fixedNumber = [425,567]
        this.option.autoCropWidth = 425
        this.option.autoCropHeight = 567
      }else if(val == 2){
        this.option.fixedNumber = [432,576]
        this.option.autoCropWidth = 432
        this.option.autoCropHeight = 576
      }
    },
    changeScale(num) {
      // 图片缩放
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    rotateLeft() {
      // 向左旋转
      this.$refs.cropper.rotateLeft()
    },
    rotateRight() {
      // 向右旋转
      this.$refs.cropper.rotateRight()
    },
    Update() {
      
    },
    realTime(data) {
      // 实时预览
      this.previews = data
    },
    cancel(){
      this.setState({cropperVisible: false})
    },
    uploadImg() {
      // 将剪裁好的图片回传给父组件
      // type = 'blob'
      // type = 'base64'
      // event.preventDefault()
      // let that = this
      // if (type === 'blob') {
      //   this.$refs.cropper.getCropBlob((data) => {
      //     const reader = new FileReader()
      //     reader.readAsDataURL(data)
      //     reader.onload = () => {
      //       that.$emit('upload', reader.result)
      //     }
      //   })
      // } else {
      //   this.$refs.cropper.getCropData((data) => {
      //     that.$emit('upload', data)
      //   })
      // }
      this.$refs.cropper.getCropData((data) => {
        // this.$emit('upload', data)
        this.setState({[this.addKey]: data,addKey: '',cropperVisible: false})
      })
    }
  },
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped>
.cropper-content {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}
 
.cropper-content .cropper {
  width: 50%;
  height: 400px;
}
 
.cropper-content .show-preview {
  height: 400px;
  flex: 1;
  -webkit-flex: 1;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  overflow: hidden;
  border: 1px solid #cccccc;
  background: rgba(195,195,195,0.5);
  margin-left: 40px;
  align-items: center
}
 
.preview {
  overflow: hidden;
  border: 1px solid #000000;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMzTjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');
}
 
.footer-btn {
  margin-top: 30px;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}
 
.footer-btn .scope-btn {
  /* width: 250px; */
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
}
 
.footer-btn .upload-btn {
  flex: 1;
  -webkit-flex: 1;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
}
 
.footer-btn .btn {
  outline: none;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 8px 15px;
  font-size: 12px;
  border-radius: 3px;
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
}

</style>